import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApi } from 'redux/apis';

export const previewJournalAction = createAsyncThunk(
	'previewJournal/get',
	async (params: any, { rejectWithValue }) => {
		try {
			const response = await getApi('/journal/entries', {
				...params,
				companyId: localStorage.getItem('companyId'),
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getJournalListingAction = createAsyncThunk(
	'getJournalListing/get',
	async (params: any, { rejectWithValue }) => {
		try {
			const response = await getApi('/journal', {
				...params,
				companyId: localStorage.getItem('companyId'),
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getJournalPaginateAction = createAsyncThunk(
	'journal/paginate',
	async (queryParameters: any, { rejectWithValue }: any) => {
		try {
			const params = {
				...queryParameters,
				companyId: localStorage.getItem('companyId'),
			};

			const response = await getApi('/journal', params);
			return response.data;
		} catch (error: any) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error?.response?.data);
		}
	}
);